import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import Accordion from '../../../../components/Accordion';
import Button from '../../../../components/Button';
import Divider from '../../../../components/Divider';
import FormContainer from '../../../../components/FormContainer';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import DatepickerRange from '../../../../components/Inputs/DatepickerRange';
import Input from '../../../../components/Inputs/Input';
import Radio from '../../../../components/Inputs/Radio';
import Select from '../../../../components/Inputs/Select';
import TextAreaInput from '../../../../components/Inputs/TextAreaInput';
import PageLoader from '../../../../components/PageLoader';
import StepProgress from '../../../../components/StepProgress';

import { useAposentadosDemitidos } from '../../../../contexts/AposentadosDemitidos/context';
import { useGlobal } from '../../../../contexts/Global/context';
import { getDateEmployeeTermination, periodoBeneficio, situacoes } from '../../../../services';

import { cloneObject } from '../../../../utils';
import steps from '../../../../utils/steps.json';
import validate from '../../../../utils/validateForm';

import schema from './schema';

import validators from '../../../../utils/defaultValidators';

import Alertas from '../Alertas';

import { ContainerButton, PageContainer } from '../../../../styles/styles';

import * as S from './styles';

function PreencherDados({ location: { beneficiario, dataMovimentacao, criticas = [] } }) {
    const history = useHistory();
    const {
        dataBeneficiario,
        setDataBeneficiario,
        setDataAposentadosDemitidos,
        dataInputForm,
        setDataInputForm,
        setAlerts,
    } = useAposentadosDemitidos();

    const {
        dataActiveContract: { informacoesEmpresa },
    } = useGlobal();

    const [dataForm, setDataForm] = useState(
        dataInputForm?.contributionDate ? cloneObject(dataInputForm) : cloneObject(schema)
    );

    const [loadingPost] = useState(false);
    const [listaSituacoes, setListaSituacoes] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);

    async function carregarSituacoes() {
        setPageLoading(true);
        const response = (await situacoes()) || [];
        setListaSituacoes(response);
        setPageLoading(false);
    }

    async function inicioContribuicao(params, form) {
        const carteirinha = dataBeneficiario?.numCarteirinha;
        const situacao = form.situation.lookup;
        const demissionDate = form.demissionDate.value;

        const query = `numCarteira=${carteirinha}&dataInicioInatividade=${demissionDate}&situacao=${situacao}&${params}`;

        const response = (await periodoBeneficio(query)) || {};

        const { dataInicioInatividadeCalculada, dataFimInatividadeCalculada } = response;

        return {
            stayCompany: {
                ...form.stayCompany,
                error: '',
                value: [dataInicioInatividadeCalculada, dataFimInatividadeCalculada],
            },
        };
    }

    function validateContribution(form) {
        const isInicioContribuicao = form.radioContribution.value === 'I';

        return {
            contributionDate: {
                ...form.contributionDate,
                required: isInicioContribuicao,
                disabled: !isInicioContribuicao,
                value: '',
                error: '',
            },
            stayCompany: {
                ...form.stayCompany,
                value: [],
                error: '',
            },
            contributionYears: {
                ...form.contributionYears,
                required: !isInicioContribuicao,
                value: isInicioContribuicao ? '' : form.contributionYears.value,
                disabled: isInicioContribuicao,
                error: '',
            },
            contributionMonths: {
                ...form.contributionMonths,
                required: !isInicioContribuicao,
                value: isInicioContribuicao ? '' : form.contributionMonths.value,
                disabled: isInicioContribuicao,
                error: '',
            },
            contributionDays: {
                ...form.contributionDays,
                required: !isInicioContribuicao,
                value: isInicioContribuicao ? '' : form.contributionDays.value,
                disabled: isInicioContribuicao,
                error: '',
            },
        };
    }

    async function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        if (!key) return;

        const form = cloneObject(dataForm);

        if (typeof validators[key] === 'function') validators[key]({ ...form, ...dataBeneficiario });
        // Valida os campos obrigatorios sem valores

        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        const fieldsTempoContribuicao = [
            'demissionDate',
            'contributionYears',
            'contributionMonths',
            'contributionDays',
            'situation',
        ];

        let dataInicioContribuicao = {};

        if (fieldsTempoContribuicao.includes(key)) {
            const newForm = { ...form, [key]: { ...form[key], id, name, value } };

            const hasEmptyValues = fieldsTempoContribuicao.filter((fieldKey) => !newForm[fieldKey].value).length > 0;

            if (newForm.radioContribution.value === 'T' && !hasEmptyValues) {
                const { contributionYears, contributionMonths, contributionDays } = newForm;

                const query = `anosContribuicao=${contributionYears.value}&mesesContribuicao=${contributionMonths.value}&diasContribuicao=${contributionDays.value}`;

                if (id === 'demissionDate') {
                    newForm.demissionDate.value = moment(value, 'DD/MM/YYYY').toISOString();
                }

                dataInicioContribuicao = await inicioContribuicao(query, newForm);
            }
        }

        setDataForm({ ...form, ...dataInicioContribuicao });
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup, ...rest } = event;

        const field = { ...dataForm[id], value, lookup, unmaskedValue, error: '', ...rest };

        const newForm = cloneObject({ ...dataForm, [id]: field });

        let validationContribution = {};

        if (id === 'radioContribution') {
            validationContribution = validateContribution(newForm) || {};
        }

        const fieldsInicioContribuicao = ['demissionDate', 'situation', 'contributionDate'];

        let dataInicioContribuicao = {};

        if (fieldsInicioContribuicao.includes(id)) {
            const hasEmptyValues = fieldsInicioContribuicao.filter((fieldKey) => !newForm[fieldKey].value).length > 0;

            if (newForm.radioContribution.value === 'I' && !hasEmptyValues) {
                const query = `dataInicioContribuicao=${newForm.contributionDate.value}`;

                dataInicioContribuicao = await inicioContribuicao(query, newForm);
            }
        }

        setDataForm({
            ...newForm,
            ...validationContribution,
            ...dataInicioContribuicao,
        });
    }

    async function handleForwardStep() {
        const { validatedForm, isValid } = validate({ ...dataForm, ...dataBeneficiario });

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (isValid) {
            setDataInputForm(dataForm);

            const payload = {
                numeroContrato: dataBeneficiario?.contrato?.numero,
                tipoAcao: 1,
                codigoEmpresa: dataBeneficiario?.empresa?.codigo,
                numeroAssociadoOuNumeroCarteira: dataBeneficiario?.numCarteirinha,
                nomeAssociado: dataBeneficiario?.nomeCompleto,
                dataInicioInatividade: dataForm?.demissionDate?.value,
                dataInicioContribuicao: dataForm?.contributionDate?.value,
                dataInicioPeriodoInatividade: dataForm?.stayCompany?.value[0],
                dataFimPeriodoInatividade: dataForm?.stayCompany?.value[1],
                situacao: dataForm?.situation?.value,
                diaPagamento: dataForm.dueDate.value,
                tipoCalculoPeriodoInatividade: dataForm?.radioContribution?.value === 'I' ? 1 : 2,
                qtdAnosContribuicao: dataForm?.contributionYears?.value,
                qtdMesesContribuicao: dataForm?.contributionMonths.value,
                qtdDiasContribuicao: dataForm?.contributionDays.value,
            };

            setDataAposentadosDemitidos(payload);

            history.push({
                pathname: '/movimentacao_cadastral/carregar_documentos_aposentados_demitidos',
            });
        } else {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            }, 300);
        }
    }

    const fetchDateTermination = async () => {
        const dateEmplyeeTermination = await getDateEmployeeTermination(dataBeneficiario.numCarteirinha);

        setDataForm({
            ...dataForm,
            demissionDate: {
                ...dataForm.demissionDate,
                error: '',
                value: moment(dateEmplyeeTermination, 'YYYY/MM/DD').toISOString(),
            },
        });
    }

    useEffect(() => {
        if (!dataBeneficiario && !beneficiario)
            history.push('/movimentacao_cadastral/selecionar_aposentados_demitidos');

        carregarSituacoes();
        fetchDateTermination(dataBeneficiario.numCarteirinha)

        if (dataMovimentacao) {
            setDataForm(dataMovimentacao);
            setDataBeneficiario(beneficiario);
            setAlerts(criticas);
        }
    }, []);

    return (
        <PageContainer>
            <StepProgress steps={steps.aposentadosDemitidos} activeStep={2} />

            <Alertas />

            <Accordion hasCollapse={false} title="Dados de beneficiário">
                <FormContainer>
                    <S.CustomInput
                        field={{
                            id: 'carteirinha',
                            label: 'N° da carteirinha',
                            value: `${dataBeneficiario?.numCarteirinha}`,
                            disabled: true,
                        }}
                    />

                    <S.CustomInput
                        field={{
                            id: 'nomeCompleto',
                            label: 'Nome completo',
                            value: dataBeneficiario?.nomeCompleto,
                            disabled: true,
                        }}
                    />
                </FormContainer>
            </Accordion>
            <Accordion hasCollapse={false}>
                <FormContainer>
                    <S.CustomInput
                        field={{
                            id: 'contrato',
                            label: 'Contrato',
                            value: `${dataBeneficiario?.contrato?.numero} - ${dataBeneficiario?.contrato?.nome}`,
                            disabled: true,
                        }}
                    />
                    <S.CustomInput
                        field={{
                            id: 'empresa',
                            label: 'Empresa',
                            value: dataBeneficiario?.empresa?.nome,
                            disabled: true,
                        }}
                    />
                </FormContainer>
            </Accordion>

            <Divider />

            <Accordion hasCollapse={false}>
                <FormContainer>
                    <Select
                        field={{
                            ...dataForm.situation,
                            options: listaSituacoes,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                </FormContainer>
            </Accordion>

            <Accordion hasCollapse={false}>
                <S.SectionContribution>
                    <S.Container>
                        <S.Label>Escolha o tipo de contribuição</S.Label>
                    </S.Container>
                    <FormContainer>
                        <Radio
                            style={{ whiteSpace: 'pre-wrap', marginTop: '24px', marginLeft: '8px' }}
                            field={{
                                ...dataForm.radioContribution,
                                options: [{ nome: 'Inicio de contribuição', codigo: 'I' }],
                            }}
                            onChange={handleChangeInput}
                            onBlur={handleInputBlur}
                        />
                        <DatepickerMui
                            field={dataForm.contributionDate}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    </FormContainer>
                    <FormContainer>
                        <Radio
                            style={{ whiteSpace: 'pre-wrap', marginTop: '24px', marginLeft: '8px' }}
                            field={{
                                ...dataForm.radioContribution,
                                options: [{ nome: 'Tempo de contribuição', codigo: 'T' }],
                            }}
                            onChange={handleChangeInput}
                            onBlur={handleInputBlur}
                        />
                        <S.ContainerContribution>
                            <Input
                                field={dataForm.contributionYears}
                                maxLength="4"
                                onBlur={handleInputBlur}
                                onChange={handleChangeInput}
                            />
                            <Input
                                field={dataForm.contributionMonths}
                                maxLength="2"
                                onBlur={handleInputBlur}
                                onChange={handleChangeInput}
                            />
                            <Input
                                field={dataForm.contributionDays}
                                maxLength="2"
                                onBlur={handleInputBlur}
                                onChange={handleChangeInput}
                            />
                        </S.ContainerContribution>
                    </FormContainer>
                </S.SectionContribution>
            </Accordion>

            <Accordion hasCollapse={false}>
                <FormContainer>
                    <DatepickerRange
                        field={dataForm.stayCompany}
                        allowEmpty={[false, true]}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <Input field={{ ...dataForm.dueDate, value: informacoesEmpresa.diaVencimentoFatura }} />
                </FormContainer>

                <TextAreaInput field={dataForm.observation} onChange={handleChangeInput} maxLength={1000} />
            </Accordion>

            <S.ShowLength>{dataForm.observation.value.length}/1000</S.ShowLength>

            <ContainerButton>
                <Button
                    id="backStep"
                    type="secondary"
                    onClick={() => history.push('/movimentacao_cadastral/selecionar_aposentados_demitidos')}
                >
                    Voltar
                </Button>

                <Button id="continueStep" type="primary" loading={loadingPost} onClick={handleForwardStep}>
                    Continuar
                </Button>
            </ContainerButton>
            <PageLoader loading={pageLoading} />
        </PageContainer>
    );
}

export default PreencherDados;
